var icon = require('vue-svgicon')
icon.register({
  'ks-icon-caret': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M96 51.79l-32 32-32-32z"/>'
  }
})
